import { SHOPPABLE_PLUGIN } from '~/utils/constants';

export const checkMikMakAvailable = (
  shoppablePlugin?: string,
  mikmak?: {
    appId?: string;
    buttonText?: string;
  }
) =>
  (mikmak &&
    SHOPPABLE_PLUGIN.MIKMAK === shoppablePlugin &&
    Boolean(mikmak.appId && mikmak.buttonText)) ||
  false;
